<template>
  <div class="login-container">
    <div v-if="loading" class="loading-overlay">
      <Loader />
    </div>
    <div v-else>
      <span class="title">Sign up for your free 14-day trial</span>
      <div class="login-content" :class="{ full: isOpenAccordion }">
        <div class="monthly-or-yearly" :class="{ full: isOpenAccordion }">
          <span
            class="monthly"
            :class="{ selected: billing_interval === 'monthly' }"
            @click.prevent="toggleBillingInterval('monthly')"
            >Monthly</span
          >
          <span
            class="yearly"
            :class="{ selected: billing_interval === 'yearly' }"
            @click.prevent="toggleBillingInterval('yearly')"
            >Yearly (2 months free)</span
          >
        </div>
        <ul class="accordion" :class="{ full: isOpenAccordion }">
          <li class="accordion-item" :class="{ active: isOpenAccordion }">
            <div class="accordion-top" @click.prevent="toggleAccordion()">
              <div class="accordion-header">
                <p class="accordion-header__plan">{{ selectedPlan.title }}</p>
                <p class="accordion-header__due-today">
                  {{ selectedPlan.dueToday }}
                </p>
                <p class="accordion-header__price">{{ selectedPlan.price }}</p>
              </div>
              <ChevronDownIcon
                class="icon chevron"
                :class="{ isOpen: isOpenAccordion }"
              />
            </div>
            <div class="accordion-content" v-show="isOpenAccordion">
              <div
                v-for="(item, i) in selectedPlan.items"
                :key="`checklist_${i}`"
                class="checklist"
              >
                <CheckIcon class="icon small" />
                <span>{{ item }}</span>
              </div>
            </div>
          </li>
        </ul>
        <div
          v-if="!discountApplied"
          class="coupon-card input"
          :class="{ full: isOpenAccordion }"
        >
          <span class="card-description">
            Have a coupon code?
          </span>
          <div class="floating-label coupon-input">
            <input
              v-model="discount"
              placeholder="Enter code"
              type="text"
              name="coupon"
              id="coupon"
              autocomplete="off"
            />
            <label for="coupon">Coupon code</label>
          </div>
          <button
            @click="applyDiscount()"
            :disabled="!discount"
            class="button-default big"
          >
            <span>Apply</span>
          </button>
        </div>
        <div v-if="discountApplied" class="coupon-card remove">
          <span class="card-description">
            Your discount is applied.
          </span>
          <div class="coupon-result">
            <img :src="'/img/Signup-DiscountSmiley.png'" />
            <span class="coupon-result" v-if="freeMonths">{{
              couponText
            }}</span>
          </div>
          <button @click="removeDixscount()" class="button-secondary big">
            <span>Remove Discount</span>
          </button>
        </div>
        <div
          v-if="authorization.length"
          v-show="!loading"
          class="card-content"
          :class="{ full: isOpenAccordion }"
        >
          <div class="card-payment">
            <v-braintree
              :card="{
                cvv: {
                  required: true
                },
                overrides: {
                  styles: {
                    input: {
                      color: 'white'
                    },
                    ':focus': {
                      color: 'white'
                    }
                  }
                }
              }"
              :authorization="authorization"
              @load="onLoad"
              @success="onSuccessCreateCustomer"
              @error="onError"
            >
              <template v-slot:button="slotProps">
                <div class="payment-footer">
                  <div class="security">
                    <div>
                      <div class="icon-holder">
                        <LockIcon />
                      </div>
                      Secure SSL Payment
                    </div>
                    <div class="">
                      <div class="icon-holder">
                        <CheckIcon class="icon small" :color="white" />
                      </div>
                      <div>100% Money Back Guarantee</div>
                    </div>
                  </div>
                  <button
                    @click.prevent="slotProps.submit"
                    class="button-default big"
                    :disabled="saving || !braintreeInstance"
                  >
                    <span>Get Started</span>
                  </button>
                </div>
              </template>
            </v-braintree>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CheckIcon from "../../../public/img/icons/check.svg";
import ChevronDownIcon from "../../../public/img/icons/chevron-white.svg";
import LockIcon from "../../../public/img/icons/lock.svg";
import Loader from "@/components/Custom/Loader";

import { mapState } from "vuex";
import {
  M_UPDATE_SIGNUP_STEP,
  Q_CHECK_DISCOUNT_COUPON,
  M_BRAINTREE_ADD_ARTISTS,
  M_ADD_FAMILY_ARTISTS,
  M_ADD_AGENCY_ARTISTS,
  M_BRAINTREE_CLIENT_TOKEN,
  M_BRAINTREE_SUBSCRIBE,
  Q_GET_USER
} from "@/graphql";

export default {
  name: "SignupWizardStepSelectPlan",
  components: {
    CheckIcon,
    ChevronDownIcon,
    LockIcon,
    Loader
  },
  data() {
    return {
      isOpenAccordion: false,
      billing_interval: "monthly",
      plan: "pro",
      plans: [
        {
          plan: "bio",
          billing_interval: "monthly",
          title: "Smart Bio",
          dueToday: "$0 due today",
          price: "$6/month per artist after trial",
          items: [
            "Unlimited bio, song, album, playlist, and podcast pages.",
            "Lifetime pre-saves subscriptions and unlimited drop day reminders.",
            "Full API pixel tracking: Meta, TikTok, Snapchat, AdWords",
            "Deeplinks to open apps and autoplay content.",
            "Bot detection and auto-blocking.",
            "Use vibe.to and listen.to domains, and any custom domains.",
            "Access to lifetime detailed marketing stats."
          ]
        },
        {
          plan: "bio",
          billing_interval: "yearly",
          title: "Smart Bio",
          dueToday: "$0 due today",
          price: "$60/year per artist after trial",
          items: [
            "Unlimited bio, song, album, playlist, and podcast pages.",
            "Lifetime pre-saves subscriptions and unlimited drop day reminders.",
            "Full API pixel tracking: Meta, TikTok, Snapchat, AdWords",
            "Deeplinks to open apps and autoplay content.",
            "Bot detection and auto-blocking.",
            "Use vibe.to and listen.to domains, and any custom domains.",
            "Access to lifetime detailed marketing stats."
          ]
        },
        {
          plan: "pro",
          billing_interval: "monthly",
          title: "Pro",
          dueToday: "$0 due today",
          price: "$19/month per artist after trial",
          items: [
            "Unlimited usage",
            "Lifetime pre-saves subscriptions and unlimited drop day reminders.",
            "Full API pixel tracking: Meta, TikTok, Snapchat, AdWords",
            "Deeplinks to open apps and autoplay content.",
            "Bot detection and auto-blocking.",
            "Access to lifetime detailed marketing stats."
          ]
        },
        {
          plan: "pro",
          billing_interval: "yearly",
          title: "Pro",
          dueToday: "$0 due today",
          price: "$190/year per artist after trial",
          items: [
            "Unlimited usage",
            "Lifetime pre-saves subscriptions and unlimited drop day reminders.",
            "Full API pixel tracking: Meta, TikTok, Snapchat, AdWords",
            "Deeplinks to open apps and autoplay content.",
            "Bot detection and auto-blocking.",
            "Access to lifetime detailed marketing stats."
          ]
        }
      ],
      yearly: false,
      discount: null,
      discountApplied: false,
      freeMonths: 1,
      discountName: null,
      discountAmount: 0,
      discountPrepend: "",
      loading: true,
      authorization: "",
      braintreeInstance: null
    };
  },
  async created() {
    try {
      // Check user plan first
      const userResult = await this.$apollo.query({
        client: "localClient",
        query: Q_GET_USER
      });

      const user = userResult.data.get_current_user_data.user;
      if (user && ["family", "agency"].includes(user.plan)) {
        // Handle family or agency plans by adding artists
        const mutationMap = {
          family: M_ADD_FAMILY_ARTISTS,
          agency: M_ADD_AGENCY_ARTISTS
        };

        const responseMap = {
          family: "braintree_add_family_artists",
          agency: "braintree_add_agency_artists"
        };

        try {
          const response = await this.$apollo.mutate({
            client: "localClient",
            mutation: mutationMap[user.plan],
            variables: {
              artists: this.artists.map(x => ({
                id: x.spotify_id,
                name: x.name,
                image: x.image || x.avatar_url,
                selected_plan: this.plan
              }))
            }
          });

          const { user: updatedUser, token } = response.data[
            responseMap[user.plan]
          ];

          if (token) {
            localStorage.setItem("token", token);
            await this.$store.dispatch("setUser", updatedUser);
            await this.$store.dispatch("setArtist", updatedUser.artists[0]);
            this.$store.commit("signup/setArtists", updatedUser.artists);
            this.next();
            return; // Exit early, no need for Braintree setup
          } else {
            throw new Error("Authentication failed");
          }
        } catch (error) {
          console.error("Error adding artists for family/agency plan:", error);
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Error: ${error.message.replace("GraphQL error: ", "")}`
          });
        }
      }

      // Get Braintree client token
      const result = await this.$apollo.mutate({
        client: "localClient",
        mutation: M_BRAINTREE_CLIENT_TOKEN
      });
      this.authorization = result.data.braintree_client_token.token;

      await this.setStep(6);
      const coupon = this.$cookies.get("coupon");
      if (coupon) {
        this.discount = coupon;
        this.freeMonths = this.$cookies.get("coupon_months");
        this.discountName = this.$cookies.get("discount_name");
        this.discountPrepend = this.$cookies.get("coupon_prepend");
        this.discountApplied = true;

        this.$cookies.remove("coupon");
        this.$cookies.remove("coupon_months");
        this.$cookies.remove("coupon_prepend");
        this.$cookies.remove("discount_name");
      } else if (this.coupon) {
        this.discount = this.coupon;
        await this.applyDiscount();
      }
    } catch (error) {
      console.error("Error during component initialization:", error);
    } finally {
      this.loading = false;
    }
  },
  computed: {
    ...mapState("signup", ["id", "coupon", "artists"]),
    litePlanPrice() {
      return this.yearly ? 90 : 9;
    },
    proPlanPrice() {
      return (this.yearly ? 190 : 19) - this.discountAmount;
    },
    maxPlanPrice() {
      return (this.yearly ? 290 : 29) - this.discountAmount;
    },
    interval() {
      return this.yearly ? "yr" : "mo";
    },
    couponText() {
      if (this.freeMonths === 1) {
        return "An extra free month!";
      } else {
        return `${this.freeMonths} extra free months!`;
      }
    },
    selectedPlan() {
      return this.plans.find(
        x =>
          x.plan === this.plan && x.billing_interval === this.billing_interval
      );
    }
  },
  methods: {
    toggleAccordion() {
      this.isOpenAccordion = !this.isOpenAccordion;
    },
    async setStep(step) {
      return await this.$apollo.mutate({
        client: "localClient",
        mutation: M_UPDATE_SIGNUP_STEP,
        variables: {
          id: this.id,
          signup_step: step
        }
      });
    },
    next() {
      this.$emit("nextStep");
    },
    // async selectPlan(plan) {
    //   if (this.loading) return;

    //   if (this.discountApplied)
    //     this.$store.commit("signup/setCoupon", this.discount);
    //   this.$store.commit("signup/setSelectedPlan", plan);
    //   this.$store.commit("signup/setIsYearlyPlan", this.yearly);
    //   this.next();
    // },
    async applyDiscount() {
      try {
        const result = await this.$apollo.query({
          client: "localClient",
          query: Q_CHECK_DISCOUNT_COUPON,
          variables: {
            coupon: this.discount
          }
        });

        console.log("Q_CHECK_DISCOUNT_COUPON", result);

        if (!result.data.check_discount_coupon.success) {
          throw new Error("Invalid coupon");
        }

        this.discountApplied = true;

        const coupon = result.data.check_discount_coupon.coupon;
        this.freeMonths = coupon.free_months;
        this.discountName = coupon.name;
        this.discountAmount = coupon.amount ?? 0;
        if (coupon.prepend) {
          this.discountPrepend = coupon.amount + " ";
        }
      } catch (e) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: "Invalid coupon"
        });

        this.removeDiscount();
      }
    },
    removeDiscount() {
      this.$store.commit("signup/setCoupon", null);
      this.freeMonths = 1;
      this.discount = null;
      this.discountName = null;
      this.discountApplied = false;
      this.discountPrepend = null;
    },
    toggleBillingInterval(selectedInterval) {
      this.billing_interval = selectedInterval;
    },
    onLoad(instance) {
      this.braintreeInstance = instance;
    },
    onError(error) {
      console.log("onerror", error);
      // Whoops, an error has occured while trying to get the nonce
    },
    async onSuccessCreateCustomer(payload) {
      let nonce = payload.nonce;
      // Do something great with the nonce...

      try {
        this.loading = true;
        await this.$apollo.mutate({
          client: "localClient",
          mutation: M_BRAINTREE_SUBSCRIBE,
          variables: {
            artists: [],
            braintree_nonce: nonce,
            coupon: this.discount,
            yearly_plan: this.billing_interval === "yearly" ? true : false
          }
        });

        let response = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_BRAINTREE_ADD_ARTISTS,
          variables: {
            artists: this.artists.map(x => ({
              id: x.spotify_id,
              name: x.name,
              image: x.image,
              selected_plan: this.plan
            })),
            coupon: this.coupon
          }
        });

        const { user, token } = response.data.braintree_add_artists;
        if (token) {
          localStorage.setItem("token", token);
          await this.$store.dispatch("setUser", user);
          await this.$store.dispatch("setArtist", user.artists[0]);
          this.$store.commit("signup/setArtists", user.artists);
          this.next();
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Something went wrong. Please try again.`
          });
        }
      } catch (err) {
        this.braintreeInstance.clearSelectedPaymentMethod();
        await this.$store.dispatch("snack", {
          type: "error",
          text: err.message.replace("GraphQL error: ", "")
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  width: 100vw;
  height: fit-content;
  /* BG/type2 */
  background: $bg-type-4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .logo-icon {
    width: 54px;
  }

  .title {
    display: block;
    text-align: center;
    margin-top: 30px;
    font-weight: bold;
    font-size: 30px;
    line-height: 42px;
    /* White */
    color: #ffffff;
    mix-blend-mode: normal;
    opacity: 0.9;
  }

  .login-content {
    max-width: 800px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
    row-gap: 32px;

    .monthly-or-yearly {
      display: flex;
      padding: 10px;
      border-radius: 25px;
      border: 2px solid white;
      display: flex;
      justify-content: space-around;
      gap: 12px;

      .monthly,
      .yearly {
        /* 12/SemiBold */
        font-weight: 600;
        font-size: 16px;
        line-height: 30px;
        /* Text/type0 */
        color: $text-type-0;
        mix-blend-mode: normal;
        opacity: 0.9;
        padding: 4px 16px;
        color: white;
        cursor: pointer;
      }

      .selected {
        background-color: white;
        color: black;
        border-radius: 25px;
        padding: 4px 16px;
      }
      .switch {
        margin: 0 12px;
      }

      .badge-default {
        margin-left: 24px;
      }
    }

    .plans {
      margin-top: 30px;
      display: grid;
      grid-gap: 24px 30px;
      grid-template-columns: 1fr 1fr 1fr;

      //grid-template-columns: repeat(auto-fill, minmax(300px, auto));
      //.create-link-box {
      //  width: 100%;
      //}
      //display: flex;
      .plan-card {
        width: 300px;
        //width: 100%;
        padding: 12px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;

        .card-title {
          padding: 12px;
          border-bottom: 1px solid $bg-type-1;

          .name {
            display: flex;

            .name-text {
              flex: 1;
              /* 18/Bold */
              font-weight: bold;
              font-size: 18px;
              line-height: 30px;
              /* White */
              color: white;
              mix-blend-mode: normal;
              opacity: 0.9;
            }
          }

          .price {
            margin-top: 12px;
            color: $text-type-0;
            font-size: 30px;
            line-height: 44px;

            //display: grid;
            span {
              margin-right: 6px;
            }

            .price-amount {
              font-weight: bold;
              color: white;
            }

            .price-unit {
              font-size: 18px;
              //line-height: 22px;
            }
          }
        }

        .card-content {
          max-width: 800px;
          //padding: 0 12px;
          padding: 12px;
          //display: flex;
          //flex-direction: column;
          //align-items: center;
          flex: 1;
          background-color: $bg-type-3;

          .list {
            display: grid;
            grid-gap: 18px;

            .list-item {
              display: flex;
              align-items: center;
              /* 12/SemiBold */
              font-weight: 600;
              font-size: 12px;
              line-height: 15px;
              /* White */
              color: #ffffff;

              &.active {
                .item-icon {
                  svg {
                    path {
                      fill: white;
                    }
                  }
                }

                span {
                  color: white;
                }
              }

              &.disabled {
                .item-icon {
                  svg {
                    path {
                      fill: #ccc;
                    }
                  }
                }

                span {
                  color: #ccc;
                }
              }

              .item-icon {
                width: 24px;
                height: 24px;
                display: flex;
                justify-content: center;
                align-items: center;

                svg {
                  path {
                    fill: $text-type-2;
                  }
                }
              }

              span {
                margin-left: 6px;
                color: $text-type-2;
              }
            }
          }
        }

        .card-footer {
          padding: 12px;
          display: flex;
          justify-content: center;
          /* button {
            width: 176px;
          } */
        }

        &.lite,
        &.max {
          background: linear-gradient(
            241.25deg,
            rgba(41, 39, 85, 0.45) 4.4%,
            rgba(41, 39, 84, 0.85) 61.77%,
            rgba(27, 24, 66, 0.45) 119.94%
          );
          box-shadow: 0 51px 69px rgba(23, 18, 43, 0.585739);
          backdrop-filter: blur(23px);
          /* Note: backdrop-filter has minimal browser support */
        }

        &.pro {
          //margin-left: 30px;
          background: #100e2a;
        }
      }
    }

    .coupon-card {
      // width: 100%;
      padding: 24px;
      display: grid;
      grid-template-columns: 1fr auto;
      grid-gap: 16px 24px;
      /* BG/type2 */
      background: $bg-type-3;
      /* Purple-stroke */
      border: 1px solid $purple-stroke;
      box-sizing: border-box;
      border-radius: 10px;

      &.input {
        width: 90%;
        grid-template-areas:
          "description desciption"
          "input apply";

        .coupon-input {
          grid-area: input;
        }

        button {
          grid-area: apply;
          width: 108px;
        }
      }

      &.remove {
        grid-template-areas:
          "description description"
          "result remove";

        .coupon-result {
          grid-area: result;
          display: flex;
          align-items: center;
          gap: 13px;

          img {
            width: 35px;
          }

          //flex-direction: column;
          span {
            /* 24/Bold */
            font-weight: bold;
            font-size: 24px;
            line-height: 42px;
            display: flex;
            align-items: center;
            color: #fffafa;
          }
        }

        button {
          grid-area: remove;
          width: 183px;
        }
      }

      .card-description {
        grid-area: description;
        /* 18/SemiBold */
        font-weight: 600;
        font-size: 18px;
        line-height: 30px;
        /* White */
        color: white;
        mix-blend-mode: normal;
        opacity: 0.9;
        //text-align: center;
        align-content: center;
        display: inline-grid;
      }
    }

    .card-content {
      .card-payment {
        background-color: $bg-type-3;
        border-radius: 10px;
        border: 1px solid $purple-stroke;
        height: 246px;
      }

      .payment-footer {
        margin-top: 16.5px;
        background-color: $bg-type-4;
        padding-bottom: 60px;

        &-mobile {
          display: none;
        }
      }
    }
  }
}

/* CSS styles from your provided code */
.accordion {
  width: 100%;
  margin-left: 0;
  list-style-type: none;
  background: $bg-type-3;
  border-radius: 10px;
}

.accordion.full {
  width: 100%;
}
.accordion[disabled] .accordion-header {
  cursor: not-allowed;
}
.accordion-top {
  position: relative;
  .chevron {
    position: absolute;
    top: 25px;
    right: 20px;
    cursor: pointer;
    transform: rotate(0deg);
    transition: 300ms;
    width: 15px !important;
  }
  .isOpen {
    transform: rotate(180deg) !important;
    transition: 300ms;
  }
}
.accordion-header {
  position: relative;
  display: block;
  padding: 16px 24px;
  color: #ffffff;
  cursor: pointer;
  &__plan {
    margin: 0;
    margin-bottom: 15px;
    font-weight: bold;
  }
  &__due-today {
    margin: 0;
    margin-bottom: 15px;

    font-weight: bold;
  }
  &__price {
    margin: 0;
    color: #b1afcd;
  }
}
.accordion-content {
  padding: 1rem;
  background-color: $bg-type-3;
  color: #0a0a0a;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease-out;
  animation: expandAccordion 0.3s ease-out forwards;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  .checklist {
    margin-bottom: 10px;
    display: flex;
    align-items: flex-start;
    gap: 4px;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
    svg {
      path {
        fill: white;
      }
    }

    span {
      width: fit-content;
    }
  }
}
.accordion-item.active .accordion-content {
  max-height: 2000px; /* Adjust to a suitable large value */
}

@keyframes expandAccordion {
  from {
    max-height: 0;
  }
  to {
    max-height: 2000px; /* Adjust to a suitable large value */
  }
}

.mobile-btn {
  display: none;
}

.payment-footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 30px;

  .security {
    display: flex;
    justify-content: center;
    column-gap: 32px;

    & div {
      display: flex;
      align-items: center;
      column-gap: 10px;
      color: $text-type-0;
    }

    .icon-holder {
      width: 40px;
      height: 40px;
      border-radius: 100%;
      background-color: $bg-type-3;
      fill: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .button-default {
    width: 60%;
  }
}

@media (max-width: 600px) {
  .card-content {
    width: 100%;
    .card-payment {
      height: 330px;
      border-radius: 10px;
      border: 1px solid $purple-stroke;
    }

    .payment-footer {
      display: flex;
      flex-flow: column;
      width: 100vw;
      margin-left: -20px;
      padding-left: 20px;
      .button-default {
        z-index: 100;
        margin: 0 auto;
        margin-top: -93px;
      }
      .security {
        margin-top: 37px;
      }
    }
  }
  .security {
    order: 2;
  }
  .button-default {
    order: 1;
  }

  .login-container {
    .title {
      text-align: center;
      margin-top: 51px;
      padding: 0 20px;
    }

    .login-content {
      padding: 0 20px;
      width: 100%;
      row-gap: 24px;

      .coupon-card {
        &.input {
          grid-template-areas:
            "description description"
            "input apply";

          button {
            width: 100%;
          }
        }

        &.remove {
          grid-template-areas:
            "description description"
            "result result"
            "remove remove";
          grid-gap: 16px 0;

          .coupon-result {
            display: flex;
            align-items: center;
            gap: 13px;
            flex-direction: column;

            img {
              width: 35px;
            }

            span {
              /* 24/Bold */
              font-weight: bold;
              font-size: 24px;
              line-height: 42px;
              display: flex;
              align-items: center;
              color: #fffafa;
            }
          }

          button {
            width: 100%;
          }
        }

        .card-description {
          grid-area: description;
          /* 18/SemiBold */
          font-weight: 600;
          font-size: 18px;
          line-height: 30px;
          /* White */
          color: white;
          mix-blend-mode: normal;
          opacity: 0.9;
        }
      }

      // &.full {
      //   // width: 90%;
      // }

      //.inputs {
      //  grid-template-columns: repeat(1, 100%);
      //  width: 100%;
      //}
      //button.continue {
      //  width: 100%;
      //}

      &.full {
        padding: 0;
      }

      .monthly-or-yearly {
        width: 100%;

        &.full {
          width: 90%;
        }
      }

      .card-content {
        .payment-footer-mobile {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 24px;
          padding: 0 25px;

          .button-default {
            width: 100%;
          }
        }

        &.full {
          width: 90%;
        }
      }
    }
  }

  // .accordion {
  //   // width: 90%;
  // }

  .accordion.full {
    width: 100%;
  }

  .mobile-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .payment-footer {
    align-items: flex-start;
    gap: 8px;

    .security {
      flex-direction: column;
      gap: 8px;

      .icon-holder {
        width: 26.5px;
        height: 26.5px;
        border: 1px solid #fff;
        border-radius: 100%;
        background-color: transparent;
      }

      div {
        color: #fff;
      }
    }

    // .button-default {
    //   display: none;
    // }
  }

  .login-container .login-content {
    .coupon-card {
      &.input {
        width: 100%;
      }
    }
    .card-content .card-payment {
      height: 326px;
    }
  }
}

@media (max-width: 782px) {
  .login-container {
    .login-content {
      padding: 0 20px;
      width: 100%;
      row-gap: 24px;
    }
  }
}

@media (max-width: 948px) {
  .payment-footer {
    .security {
      width: 100%;
      flex-direction: column;
      align-items: flex-start;
      row-gap: 12px;
    }
  }
}

@media (max-width: 962px) {
  .plans {
    display: grid;
    grid-template-columns: repeat(1, 100%) !important;

    .plan-card {
      width: 100%;
    }
  }
}

@media (max-width: 395px) {
  .login-container {
    .login-content {
      .monthly-or-yearly {
        .monthly,
        .yearly {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
        }
      }
    }
  }
}

@media only screen and (min-width: 1250px) {
  .login-container .login-content .coupon-card.input {
    width: 90%;
    grid-template-areas: "description input apply";
  }
}

// Loading styles
.loading-overlay {
  width: 100vw;
  height: 100vh;
  background-color: $bg-type-4;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
}
</style>
